<div *transloco="let t; prefix: scope" class="relative flex flex-col items-center justify-center overflow-hidden">
  <strong class="mb-4 block text-white">{{ t('switchProfileOverlay', { name: profile.name }) }}</strong>

  <svg class="animate-spin" xmlns="http://www.w3.org/2000/svg" width="134" height="134" fill="none">
    <g clip-path="url(#a)">
      <g clip-path="url(#b)" data-figma-skip-parse="true">
        <foreignObject width="2029.85" height="2029.85" x="-1014.93" y="-1014.93" transform="matrix(.067 0 0 .067 67 67)"
          ><div
            xmlns="http://www.w3.org/1999/xhtml"
            style="background: conic-gradient(from 90deg, rgba(255, 255, 255, 0) 0deg, #fff 360deg); height: 100%; width: 100%; opacity: 1"
          ></div
        ></foreignObject>
      </g>
      <path
        d="M130.65 67c1.85 0 3.359-1.5 3.266-3.349A66.998 66.998 0 0 0 .132 62.793 67 67 0 0 0 132.97 78.709c.323-1.822-.985-3.5-2.821-3.731-1.835-.232-3.502 1.07-3.835 2.89a60.305 60.305 0 0 1-64.988 49.164 60.3 60.3 0 1 1 65.882-63.38C127.31 65.498 128.8 67 130.65 67Z"
        data-figma-gradient-fill='{"type":"GRADIENT_ANGULAR","stops":[{"color":{"r":1.0,"g":1.0,"b":1.0,"a":0.0},"position":0.0},{"color":{"r":1.0,"g":1.0,"b":1.0,"a":1.0},"position":1.0}],"stopsVar":[{"color":{"r":1.0,"g":1.0,"b":1.0,"a":0.0},"position":0.0},{"color":{"r":1.0,"g":1.0,"b":1.0,"a":1.0},"position":1.0}],"transform":{"m00":134.0,"m01":2.0160598451085532e-13,"m02":-1.7852386235972517e-13,"m10":-2.7599092716074081e-13,"m11":134.0,"m12":2.6778579353958776e-13},"opacity":1.0,"blendMode":"NORMAL","visible":true}'
      />
    </g>
    <defs>
      <clipPath id="b">
        <path
          d="M130.65 67c1.85 0 3.359-1.5 3.266-3.349A66.998 66.998 0 0 0 .132 62.793 67 67 0 0 0 132.97 78.709c.323-1.822-.985-3.5-2.821-3.731-1.835-.232-3.502 1.07-3.835 2.89a60.305 60.305 0 0 1-64.988 49.164 60.3 60.3 0 1 1 65.882-63.38C127.31 65.498 128.8 67 130.65 67Z"
        />
      </clipPath>
      <clipPath id="a"><path fill="#fff" d="M0 0h134v134H0z" /></clipPath>
    </defs>
  </svg>

  <div #avatar class="absolute top-[67px]">
    <rma-avatar [name]="profile.name" [avatar]="profile.image" avatarStyle="block w-20 h-20 rounded-full text-xl font-bold" />
  </div>
</div>
